export enum AvailabilitiesScreenNames {
  MAIN = 'availabilities',
  AVAILABILITY = 'availability',
  AVAILABILITY_PERIOD = 'availability-period',
}
